export default __webpack_public_path__ + "static/media/people2.0eeba8b5.jpeg";